import React from "react";
import { Button, Col, DatePicker, Form, Input, InputNumber, Row, Select } from "antd";
import SubscriptionDrawerShell from "./SubscriptionDrawerShell";
import { PLAN_STATUS_OPTIONS, PLAN_TYPE_OPTIONS, getPlanFormValues } from "./subscriptionConstants";

const { TextArea } = Input;

export default function SubscriptionPlanDrawer({
  open,
  editingPlan,
  form,
  saving,
  onClose,
  onSave,
}) {
  return (
    <SubscriptionDrawerShell
      open={open}
      title={editingPlan ? "Edit subscription plan" : "Create subscription plan"}
      width={840}
      onClose={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button key="save" type="primary" onClick={onSave} loading={saving}>
          {editingPlan ? "Save changes" : "Create"}
        </Button>,
      ]}
    >
      <Form layout="vertical" form={form} initialValues={getPlanFormValues()}>
        <Row gutter={12}>
          <Col xs={24} md={12}>
            <Form.Item
              name="name"
              label="Name"
              rules={[{ required: true, message: "Enter a plan name" }]}
            >
              <Input placeholder="Premium Business" />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              name="code"
              label="Code"
              rules={[{ required: true, message: "Enter a unique code" }]}
            >
              <Input placeholder="PREMIUM_BUSINESS" />
            </Form.Item>
          </Col>
          <Col xs={24} md={8}>
            <Form.Item
              name="subscriptionType"
              label="Type"
              rules={[{ required: true, message: "Select a type" }]}
            >
              <Select options={PLAN_TYPE_OPTIONS} />
            </Form.Item>
          </Col>
          <Col xs={24} md={8}>
            <Form.Item name="status" label="Status">
              <Select options={PLAN_STATUS_OPTIONS} />
            </Form.Item>
          </Col>
          <Col xs={24} md={8}>
            <Form.Item name="startDate" label="Start date">
              <DatePicker
                showTime={{ format: "hh:mm A" }}
                format="MMMM D, YYYY hh:mm A"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={8}>
            <Form.Item name="expiryDate" label="Expiry date">
              <DatePicker
                showTime={{ format: "hh:mm A" }}
                format="MMMM D, YYYY hh:mm A"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={8}>
            <Form.Item name="monthlyAmount" label="Monthly amount">
              <InputNumber min={0} step={0.01} style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col xs={24} md={8}>
            <Form.Item name="annualAmount" label="Annual amount">
              <InputNumber min={0} step={0.01} style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col xs={24}>
            <Form.Item name="description" label="Description">
              <TextArea rows={4} placeholder="Plan summary and limits" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </SubscriptionDrawerShell>
  );
}
